import React from 'react'

import Code from './components/Code'
import Main from './components/Main'
import { logger } from './utils/logger'

import './css/index.css'
import './css/main/colors.css'
import './css/main/fonts.css'
import './css/main/general.css'

logger.debug('App initialized, URL:', window.location.href)

const App = () => {
    if (window.location.href.endsWith('/code/')) return <Code />

    return <Main />
}

export default App
